import { Box } from '@cp/ds/src/components/box';
import React from 'react';
import LazyHydrate from 'react-lazy-hydration';
import { CatalogFeedbacks } from './index';
import { CatalogFeedbacksProps } from './types';

export type CatalogFeedbacksSectionProps = CatalogFeedbacksProps;

/**
 * Defers feedbacks fetch/render until the block is near the viewport.
 * Uses a single RTK subscription inside {@link CatalogFeedbacks}.
 */
export const CatalogFeedbacksSection: React.FC<CatalogFeedbacksSectionProps> = (props) => {
  return (
    <LazyHydrate whenVisible>
      <Box sx={{ display: 'flex', flexDirection: 'column', pt: 2 }}>
        <CatalogFeedbacks {...props} />
      </Box>
    </LazyHydrate>
  );
};
